var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupportAgent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 -960 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M440-120v-60h340v-304q0-58-25-111.5T688-690q-42-41-96-65.5T480-780q-58 0-112 24.5T272-690q-42 41-67 94.5T180-484v244h-20q-33 0-56.5-23.5T80-320v-80q0-23 11-40.5t29-28.5l3-53q9-73 41.5-132t81-100q48.5-41 109-63.5T480-840q66 0 126.5 22.5t108.5 64q48 41.5 80.5 100T837-523l3 52q18 9 29 26.5t11 38.5v92q0 22-11 39t-29 26v69q0 24.75-17.625 42.375T780-120H440Zm-80-290q-12 0-21-9t-9-21.5q0-12.5 9-21t21.5-8.5q12.5 0 21 8.625T390-440q0 12-8.625 21T360-410Zm240 0q-12 0-21-9t-9-21.5q0-12.5 9-21t21.5-8.5q12.5 0 21 8.625T630-440q0 12-8.625 21T600-410Zm-359-52q-4-59 16.5-107t55-81.5Q347-684 392-702t90-18q91 0 153 57.5T711-519q-94-1-165.5-50.5T435-698q-16 81-67.5 143.5T241-462Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportAgent);
export default __webpack_public_path__ + "static/media/support_agent.00a503058a532cf794f2f84b7b2a2154.svg";
export { ForwardRef as ReactComponent };